export function getGigya() {
  if (typeof window !== 'undefined' && window.gigya) {
    return window.gigya;
  }
  throw new Error('Gigya SDK not loaded yet');
}

export async function checkLoginStatus() {
  const gigya = getGigya();

  return new Promise((resolve, reject) => {
    gigya.accounts.getAccountInfo({
      callback: (res) => {
        if (res.errorCode === 0) {
          resolve(res);
        } else {
          reject(res);
        }
      },
    });
  });
}
